// src/services/userService.js
import api from './api';

const getAllUsers = (params = {}) => {
  return api.get('/superadmin/users', { params });
};

const getSuperadminDashboardStats = () => {
  return api.get('/superadmin/dashboard-stats');
};

const getLimiterStatus = () => {
  return api.get('/root/limiter-status');
};

const deleteUser = (userId) => {
  return api.delete(`/superadmin/users/${userId}`);
};

const updateUserStatus = (userId, status) => {
  return api.patch(`/superadmin/users/${userId}/status`, { status });
};

const createUser = (userData) => {
  return api.post('/superadmin/users/create', userData);
};

const updateUser = (userId, userData) => {
  return api.put(`/superadmin/users/${userId}`, userData);
};

const getUser = (userId) => {
  return api.get(`/superadmin/users/${userId}`);
};

const clearCache = () => {
  return api.post('/superadmin/cache/clear');
};

const getCategories = () => {
  return api.get('/superadmin/categories');
};

const createCategory = (data) => {
  return api.post('/superadmin/categories', data);
};

const getCategoryGroups = () => {
  return api.get('/superadmin/category-groups');
};

const createCategoryGroup = (data) => {
  return api.post('/superadmin/category-groups', data);
};

const getUniversalVariables = () => {
  return api.get('/superadmin/universal-variables');
};

const createUniversalVariable = (data) => {
  return api.post('/superadmin/universal-variables', data);
};

const triggerSegmentation = () => {
  return api.post('/superadmin/segmentation/calculate');
};

const getSegmentationIntersection = (params) => {
  return api.get('/superadmin/segmentation/intersection', { params });
};

const deleteCategory = (id) => api.delete(`/superadmin/categories/${id}`);
const deleteCategoryGroup = (id) => api.delete(`/superadmin/category-groups/${id}`);
const deleteUniversalVariable = (key) => api.delete(`/superadmin/universal-variables/${key}`);
const getSegmentationStats = () => api.get('/superadmin/segmentation/stats');
const getSegmentationOverlapMatrix = () => api.get('/superadmin/segmentation/overlap-matrix');

const userService = {
  getAllUsers,
  getSuperadminDashboardStats,
  getLimiterStatus,
  deleteUser,
  updateUserStatus,
  createUser,
  updateUser,
  getUser,
  clearCache,
  getCategories,
  createCategory,
  getCategoryGroups,
  createCategoryGroup,
  getUniversalVariables,
  createUniversalVariable,
  triggerSegmentation,
  getSegmentationIntersection,
  deleteCategory,
  deleteCategoryGroup,
  deleteUniversalVariable,
  getSegmentationStats,
  getSegmentationOverlapMatrix,
};

export default userService;